import React from 'react';
import { DocPrintApiPayload } from '@data/docPrint/types/DocPrintRequest';
import useGetDocPrint from '@data/docPrint/hooks/useGetDocPrint';
import { useCaseDetailsPageContext } from '@components/CaseDetails/CaseDetailsContext/CaseDetailsPageContext/CaseDetailsPageContext';

const useSubmitDocPrint = () => {
	const { selectedAttachment } = useCaseDetailsPageContext();
	const getDocPrint = useGetDocPrint();
	const documentId = selectedAttachment?.id;

	return React.useCallback(() => {
		if (!documentId) {
			return;
		}

		const updateDocPrintPayload: DocPrintApiPayload = {
			data: {
				id: documentId,
			},
		};

		getDocPrint(updateDocPrintPayload);
	}, [documentId, getDocPrint]);
};

export default useSubmitDocPrint;
